import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';

// Generate time options in 12-hour format with 30-minute increments
const generateTimeOptions = () => {
  const options = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      const ampm = hour < 12 ? 'AM' : 'PM';
      const displayTime = `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
      const value24 = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      options.push({ display: displayTime, value: value24 });
    }
  }
  return options;
};

const TIME_OPTIONS = generateTimeOptions();

// Convert 24-hour time to 12-hour display format
const to12HourFormat = (time24) => {
  if (!time24) return '';
  const [hours, minutes] = time24.split(':').map(Number);
  const hour12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const ampm = hours < 12 ? 'AM' : 'PM';
  return `${hour12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
};

export const TimePicker = ({ 
  value, 
  onChange, 
  placeholder = "Select time",
  className = "",
  disabled = false
}) => {
  return (
    <Select 
      value={value || "none"} 
      onValueChange={(v) => onChange(v === "none" ? "" : v)}
      disabled={disabled}
    >
      <SelectTrigger className={`bg-slate-950 border-slate-800 text-white ${className}`}>
        <SelectValue placeholder={placeholder}>
          {value ? to12HourFormat(value) : placeholder}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-slate-900 border-slate-800 max-h-[300px]">
        <SelectItem value="none" className="text-slate-400">{placeholder}</SelectItem>
        {TIME_OPTIONS.map(option => (
          <SelectItem 
            key={option.value} 
            value={option.value} 
            className="text-white"
          >
            {option.display}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default TimePicker;
